import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, notification } from 'antd';
import {
	Logo,
	Title,
	XForm,
	XLottie,
	XThemeLottieCard,
} from '../Login/LoginStyle';
import { CenterWrapper } from '../ForgotEmailPassword/ForgotEmailPasswordStyle';
import { XPinInput, XPara1 } from './VerifyOtpStyle';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import LoginAnimation from '../../json/Reclaim.json';
import Navbar from 'react-bootstrap/Navbar';
import {
	XContainer,
	XThemeContainer,
	XThemeGradientButton,
} from '../../styles/GlobalThemeStyle';
// Actions
import { verifyOtpApi, verifyOtpReset } from '../../actions/verifyOtpAction';
import {
	sendPasswordResetEmailApi,
	sendPasswordResetEmailReset,
} from '../../actions/sendPasswordResetEmailAction';
import {
	XTheme2Button,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';

const VerifyOtp = (props) => {
	const {
		verifyOtp,
		verifyOtpReset,
		verifyOtpState,
		sendPasswordResetEmail,
		sendPasswordResetEmailState,
		sendPasswordResetEmailReset,
	} = props;
	const [form] = XForm.useForm();
	const [formData, setFormData] = useState({
		email: localStorage.getItem('email'),
	});
	const navigate = useNavigate();

	useEffect(() => {
		if (sendPasswordResetEmailState.apiState === 'success') {
			notification.success({
				message: sendPasswordResetEmailState.message,
			});
			sendPasswordResetEmailReset();
		} else if (sendPasswordResetEmailState.apiState === 'error') {
			notification.error({
				message: sendPasswordResetEmailState.message,
			});
			sendPasswordResetEmailReset();
		}
	}, [sendPasswordResetEmailState]);

	useEffect(() => {
		if (verifyOtpState.apiState === 'success') {
			localStorage.setItem('otpVerified', true);
			verifyOtpReset();
			navigate('/reset-password');
		} else if (verifyOtpState.apiState === 'error') {
			notification.error({
				message: verifyOtpState.message,
			});
			verifyOtpReset();
		}
	}, [verifyOtpState]);
	useEffect(() => {
		document.body.classList.add('bodyOverflowHideImageBg');
		return () => {
			document.body.classList.remove('bodyOverflowHideImageBg');
		};
	}, []);
	return (
		<XThemeContainer fluid>
			<Row className="align-items-center my-5" gutter={[15, 15]}>
				<Col xs={24} className="d-flex justify-content-start">
					<span className="logo">
						<img
							style={{ width: 100 }}
							src={'/images/reclaim-revolution-logo.svg'}
							alt="logo"
						/>
					</span>
				</Col>
			</Row>
			<CenterWrapper className="align-items-center h-auto">
				<Row className="align-items-center w-100">
					<Col
						xs={{ span: 24, offset: 0 }}
						sm={{ span: 24, offset: 0 }}
						md={{ span: 12, offset: 6 }}
						lg={{ span: 8, offset: 8 }}
					>
						<div className="w-50 m-auto text-center">
							<XThemeLottieCard>
								<XLottie
									animationData={LoginAnimation}
									loop={true}
								/>
							</XThemeLottieCard>
						</div>
						<XTheme2MainTitle className="my-4 text-center">
							OTP Verification
						</XTheme2MainTitle>
						<XPara1 className="mb-4 text-center">
							We sent a verification code to
							<span> {formData.email}</span>
						</XPara1>
						<XForm
							form={form}
							name="loginForm"
							layout="vertical"
							autoComplete="off"
							onFinish={() => verifyOtp(formData)}
							className="w-100"
						>
							<XForm.Item
								name="otp"
								className="text-center"
								rules={[
									{
										required: true,
										message: 'Please enter OTP',
									},
								]}
							>
								<XPinInput
									focus="true"
									length={6}
									initialvalue=""
									onChange={(value, index) => {
										setFormData({
											...formData,
											otp: value,
										});
									}}
									type="numeric"
									inputMode="number"
									style={{ padding: '0px' }}
									inputStyle={{
										borderColor: '#D8D8D7',
										background: '#F7F9FD',
										padding: '5px',
										width: '60px',
										height: '60px',
										fontSize: '2rem',
										marginRight: '15px',
										marginBottom: '15px',
									}}
									inputFocusStyle={{
										borderColor: '#D8D8D7',
										background: '#F7F9FD',
									}}
									onComplete={(value, index) => {}}
									autoSelect={true}
									regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
								/>
							</XForm.Item>

							<XForm.Item className="mt-4 text-center">
								{/* <XPara1 className="mb-1">00:20</XPara1> */}
								<XPara1 className="mb-0">
									Don't Receive the OTP?{' '}
									<span
										onClick={() => {
											sendPasswordResetEmail({
												email: localStorage.getItem(
													'email',
												),
											});
										}}
									>
										RESEND
									</span>
								</XPara1>
							</XForm.Item>

							<XForm.Item className="mt-4">
								<XTheme2Button
									htmlType="submit"
									className="w-100 py-4"
								>
									Submit
								</XTheme2Button>
							</XForm.Item>
						</XForm>
					</Col>
				</Row>
			</CenterWrapper>
		</XThemeContainer>
	);
};

const mapStateToProps = (state) => ({
	verifyOtpState: state.verifyOtp,
	sendPasswordResetEmailState: state.sendPasswordResetEmail,
});

const mapDispatchToProps = (dispatch) => ({
	verifyOtp: (params) => dispatch(verifyOtpApi(params)),
	verifyOtpReset: () => dispatch(verifyOtpReset()),
	sendPasswordResetEmail: (params) =>
		dispatch(sendPasswordResetEmailApi(params)),
	sendPasswordResetEmailReset: () => dispatch(sendPasswordResetEmailReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyOtp);
